module.exports = __webpack_public_path__ + "static/media/lungdis_help1553.75142620.png";